module.exports = __webpack_public_path__ + "img/shangchuan.af6e6fd0.png";